import { NewsOrigin } from '../shared/enum/NewsOrigin';

export interface SpreadsheetModel {
    id: number,
    clientId: number,
    clientDescription: string, 
    clipperId: number,
    clipperDescription: string, 
    creationDate: Date,
    statusNews: string,
    fileDescription: string,
    newsByStatus: number,
    totalNews: number,
    newsOrigin: NewsOrigin | null
}

export const spreadsheetModelInitial: SpreadsheetModel = {
    id: 0,
    clientId: 0,
    clientDescription: '', 
    clipperId: 0,
    clipperDescription: '', 
    creationDate: new Date(),
    statusNews: '',
    fileDescription: '',
    newsByStatus: 0,
    totalNews: 0,
    newsOrigin: null
};